import { useAttrs, provide, inject, ref, computed } from "vue";
const criticalContextKey = Symbol("criticalContext");
export default function useBoosterCritical(options = {}) {
  const attrs = useAttrs();
  const { critical } = { critical: void 0, ...options };
  const currentCritical = ref(
    !("critical" in attrs) ? critical : attrs.critical === "" || String(attrs.critical) === "true"
  );
  const criticalInject = inject(
    criticalContextKey,
    currentCritical.value || false
  );
  const isCritical = computed(() => {
    return typeof currentCritical.value === "boolean" ? currentCritical.value : criticalInject;
  });
  provide(criticalContextKey, isCritical.value || critical);
  return {
    isCritical
  };
}
